import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
const includes = ['Plan de alimentación personalizado y flexible', 'Rutinas de movimiento adaptadas a tu nivel', 'Guías prácticas de bienestar mental y espiritual', '4 Sesiones grupales en vivo al mes (Q&A y coaching)', 'Acceso a comunidad privada de apoyo 24/7', 'Seguimiento semanal de progreso', 'Librería de recursos descargables y plantillas'];
export function OfferStack() {
  return <section className="py-24 bg-white relative" data-id="element-186">
      <div className="max-w-5xl mx-auto px-6" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-188">
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-189">
            Todo lo que incluye tu transformación
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-190">
            Un ecosistema completo diseñado para acompañarte paso a paso durante
            tus 90 días.
          </p>
        </motion.div>

        <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-xl border border-gold/20 relative overflow-hidden" data-id="element-191">
          {/* Decorative corner */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold/10 rounded-full blur-2xl" data-id="element-192"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 relative z-10" data-id="element-193">
            <div className="space-y-6" data-id="element-194">
              {includes.slice(0, 4).map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.1
            }} className="flex items-start gap-4" data-id="element-195">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-196" />
                  <span className="font-medium text-lg text-[#0D1B3E]" data-id="element-197">
                    {item}
                  </span>
                </motion.div>)}
            </div>
            <div className="space-y-6" data-id="element-198">
              {includes.slice(4).map((item, idx) => <motion.div key={idx + 4} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: (idx + 4) * 0.1
            }} className="flex items-start gap-4" data-id="element-199">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-200" />
                  <span className="font-medium text-lg text-[#0D1B3E]" data-id="element-201">
                    {item}
                  </span>
                </motion.div>)}

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.8
            }} className="mt-8 text-cream p-6 rounded-2xl border border-gold/30 shadow-lg bg-[#0D1B3E]" data-id="element-202">
                <div className="flex items-center gap-3 mb-2" data-id="element-203">
                  <Gift className="w-6 h-6 text-gold" data-id="element-204" />
                  <h4 className="font-serif text-xl text-gold font-semibold" data-id="element-205">
                    BONO EXCLUSIVO
                  </h4>
                </div>
                <p className="text-cream/90 font-medium" data-id="element-206">
                  Diagnóstico RenuevaTE_90 personalizado y sesión de claridad
                  inicial (Valorado en $150 USD - Hoy GRATIS)
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}